// ======================================================================
// File Name       : ReportOperationAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import * as ModalIds from '../constants/ModalIds';
import { openModal } from './ModalAction';
import * as ActionTypes from '../constants/actionTypes/report';
import * as groupRequests from './httpRequests/group';

export function openReportDialog(data) {
  return (dispatch, getState) => {
    dispatch(receiveReportData(data));
    dispatch(openModal(ModalIds.REPORT_MODAL_DIALOG));
  };
}

export function receiveReportData(data) {
  return {
    type: ActionTypes.OPEN_REPORT_DIALOG,
    data,
  };
}

export function initReportListSearchData(data, isValidUrl, mode) {
  return {
    type: ActionTypes.REPORT_LIST_INIT_SEARCH_INFO,
    data,
    isValidUrl,
    mode,
  };
}

export function fetchGroupStructure() {
  return dispatch =>
    groupRequests
      .postGroupGetStructure()
      .then(({ groupList }) => dispatch(doReceiveGroupStructureList(groupList)));
}

function doReceiveGroupStructureList(groupList) {
  return {
    type: ActionTypes.REPORT_LIST_GET_GROUP_LIST,
    groupList,
  };
}
